
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TextArea',
  props: {
    focus: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function onChanged(e: any): void {
      emit('update:modelValue', e.currentTarget.value)
    }

    return {
      onChanged
    }
  },
  mounted() {
    if (this.focus) {
      const textarea = this.$refs.textarea as HTMLTextAreaElement
      textarea.focus()
    }
  }
})
